import React from 'react';
import {
  FaSpinner,
  FaCheck,
  FaTimes,
  FaEye,
  FaMapMarkerAlt,
  FaInstagram,
} from 'react-icons/fa';

const CampaignApplicantsTableView = ({
  applications,
  updatingStatus,
  onViewDetails,
  onAccept,
  onReject,
  canShowActions,
  // getStatusColor,
  formatDate,
  getCountryName,
}) => {
  const getInitial = (name) => {
    if (!name) return '?';
    return name.charAt(0).toUpperCase();
  };

  if (applications.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[800px]">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Applicant
              </th>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Instagram
              </th>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Followers
              </th>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Location
              </th>
              {/* <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Status
              </th> */}
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Applied Date
              </th>
              <th className="px-4 lg:px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Actions
              </th>
              <th className="px-4 lg:px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                View
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {applications.map((application) => (
              <tr
                key={application._id}
                className="hover:bg-gray-50 transition-colors"
              >
                {/* Applicant */}
                <td className="px-4 lg:px-6 py-4">
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="h-10 w-10 rounded-full border-2 border-orange-500 bg-white shadow-sm flex items-center justify-center text-lg font-bold text-orange-500 overflow-hidden flex-shrink-0">
                      {application.profileImage ? (
                        <img
                          src={application.profileImage}
                          alt={application.name}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        getInitial(application.name)
                      )}
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-semibold text-gray-900 truncate">
                        {application.name}
                      </p>
                      <p className="text-xs text-gray-500 truncate">
                        {application.email || 'N/A'}
                      </p>
                    </div>
                  </div>
                </td>

                {/* Instagram */}
                <td className="px-4 lg:px-6 py-4">
                  <div className="flex items-center gap-2 min-w-0">
                    <FaInstagram className="text-orange-500 text-sm flex-shrink-0" />
                    <a
                      href={application.instagramProfileLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-blue-600 hover:text-blue-800 hover:underline truncate"
                    >
                      @{application.instagramUsername || 'N/A'}
                    </a>
                  </div>
                </td>

                {/* Followers */}
                <td className="px-4 lg:px-6 py-4 whitespace-nowrap">
                  <div className="text-sm">
                    <p className="font-semibold text-gray-900">
                      {application.followerCount?.toLocaleString() || '0'}
                    </p>
                    <p className="text-xs text-gray-500">
                      {application.mediaCount?.toLocaleString() || '0'} posts
                    </p>
                  </div>
                </td>

                {/* Location */}
                <td className="px-4 lg:px-6 py-4">
                  <div className="flex items-center gap-2 text-sm text-gray-700 min-w-0">
                    <FaMapMarkerAlt className="text-gray-400 text-xs flex-shrink-0" />
                    <span className="truncate">
                      {application.location?.city || 'N/A'},{' '}
                      {getCountryName(application.location?.country)}
                    </span>
                  </div>
                </td>

                {/* Status */}
                {/* <td className="px-4 lg:px-6 py-4 whitespace-nowrap">
                  <span
                    className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(
                      application.status
                    )}`}
                  >
                    {application.status}
                  </span>
                </td> */}

                {/* Applied Date */}
                <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                  {formatDate(application.createdAt)}
                </td>

                {/* Actions */}
                <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-center">
                  {canShowActions(application.status) ? (
                    <div className="flex items-center justify-center gap-2 flex-wrap">
                      <button
                        onClick={() => onAccept(application)}
                        disabled={updatingStatus[application._id]}
                        className="inline-flex items-center px-2 lg:px-3 py-1.5 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Accept"
                      >
                        {updatingStatus[application._id] ? (
                          <FaSpinner className="animate-spin" />
                        ) : (
                          <>
                            <FaCheck className="mr-1" />
                            <span className="hidden lg:inline">Approve</span>
                          </>
                        )}
                      </button>
                      <button
                        onClick={() => onReject(application)}
                        disabled={updatingStatus[application._id]}
                        className="inline-flex items-center px-2 lg:px-3 py-1.5 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Reject"
                      >
                        {updatingStatus[application._id] ? (
                          <FaSpinner className="animate-spin" />
                        ) : (
                          <>
                            <FaTimes className="mr-1" />
                            <span className="hidden lg:inline">Reject</span>
                          </>
                        )}
                      </button>
                    </div>
                  ) : application.status === 'accepted' || application.status === 'approved' ? (
                    <span className="inline-flex items-center px-3 py-1.5 bg-green-100 text-green-700 rounded-lg text-xs font-semibold">
                      <FaCheck className="mr-1.5" />
                      Accepted
                    </span>
                  ) : application.status === 'rejected' ? (
                    <span className="inline-flex items-center px-3 py-1.5 bg-red-100 text-red-700 rounded-lg text-xs font-semibold">
                      <FaTimes className="mr-1.5" />
                      Rejected
                    </span>
                  ) : (
                    <span className="text-xs text-gray-400">No actions</span>
                  )}
                </td>

                {/* View */}
                <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-center">
                  <button
                    onClick={() => onViewDetails(application)}
                    className="inline-flex items-center px-3 lg:px-4 py-2 text-sm font-medium text-orange-600 hover:text-orange-700 hover:bg-orange-50 rounded-lg transition-colors"
                  >
                    <FaEye className="mr-1 lg:mr-2" />
                    <span className="hidden lg:inline">View</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CampaignApplicantsTableView;

